export default "__VITE_ASSET__b6491925__"